import { Injectable } from '@angular/core';

export interface DeliveredQtyCostPercentModel {
  dayOrMonth: string | number;
  deliveredQty: number;
  costPercentage: number;
  deliveredQtyUnit: string;
}

export interface CostContributtionbyABCDModel {
  costContributionPercentage: number;
  abcd: string | number;
}

@Injectable({
  providedIn: 'root'
})

export class DataAnalyticsHelperService {

  constructor() { }

  barLineComboDataMapper(array: DeliveredQtyCostPercentModel[]): any {

    return {
      barData: array.map(item => item.deliveredQty),
      lineData: array.map(item => item.costPercentage),
      xAxisLabels: array.map(item => item.dayOrMonth)
    };
  }

  CCbarData(array: CostContributtionbyABCDModel[]): any {
    const data = [];
    array.forEach(element => {
      data.push({
        label: element.abcd.toString().length > 0 ? element.abcd : ' ',
        val: element.costContributionPercentage
      });
    });

    data.sort((a, b) => {
      return b.val - a.val;
    });
    return data;
  }

  setInsightsArr(level: string): Array<string> {
    if (level === 'factory') {
      return [
        'GetMostWasteContributingSKU',
        'GetMostWasteContributingRMMaterial',
        'GetMostWasteContributingPMMaterial',
        'GetMostWasteContributingLine',
        'GetAlternateBOMComponent',
        'GetAlternateLineforSKU',
        'GetBomNetoffWaste',
        'GetLineContributingNegativeWaste',
        'GetQuantityandCostPercentChange',
        'GetPlannedVsActualRecipe'
      ];
    } else {
      return [
        'GetPMDecQtyandIncCost',
        'GetRMDecQtyandIncCost',
        'GetRMIncQtyandDecCost',
        'GetPMIncQtyandDecCost',
        'GetLineInsightPlannedvsActual',
        'GetSkuDecQtyIncCost',
        'GetLineQtyandCostChange',
        'GetOEEandcostchange',
        'GetLinevariationLineinsight',
        'GetChangeOverandCostchange',
        'GetSkuWithHighestNegativeWaste',
        'GetAlternateBOMForLine'

      ];
    }
  }

  setParamsForInsights(factorySummary: any, lineId: string, insightLevel: string) {
    const params: any = {
      FactoryKey: factorySummary.factoryId,
      StartDate: factorySummary.fromDate,
      EndDate: factorySummary.toDate
    };
    if (insightLevel === 'line') {
      params.LineId = lineId;
    }
    return params;
  }

  // setLabels(chartType: string) {
  //   let labels = {
  //     x: null,
  //     y: null,
  //     y2: null
  //   };
  //   switch (chartType) {
  //     case 'deliveredQtyVsCostLine':
  //       labels = {
  //         x: null,
  //         y: 'Sum of Delivered Quantity',
  //         y2: 'Cost %'
  //       }
  //   }

  //   return labels;
  // }
}
